<script>
  import { beforeUpdate } from 'svelte';

  export let value = '';
  export let style = '';
  export let classNames = '';
  export let role = '';
  export let busy = false;
  export let disabled = false;

  let effectiveStyles = '';

  beforeUpdate(() => {
    switch (role) {
      case 'confirm':
        effectiveStyles = 'btn btn-secondary ';
        break;

      case 'cancel':
        effectiveStyles = 'btn btn-panel ';
        break;

      case 'reset':
        effectiveStyles = 'btn btn-info ';
        break;
    }

    if (effectiveStyles !== classNames) {
      effectiveStyles = (effectiveStyles + ' ' + classNames).trim();
    }
  });
</script>

<style>
  .spin {
    animation-name: spin;
    animation-duration: 1000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  @keyframes spin {
      from {
          transform:rotate(0deg);
      }
      to {
          transform:rotate(360deg);
      }
  }
</style>

<button
  class={effectiveStyles}
  style={style}
  on:click
  on:blur
  on:focus
  on:dblclick
  on:contextmenu
  disabled={disabled || busy}
  value={value}>
  {#if busy}
  <i class="fas fa-spinner spin"></i>
  {:else}
  <slot></slot>
  {/if}
</button>